<script setup lang="ts">
import { defineProps, ref } from 'vue'
import { ApiCryptoWalletRequest, postCryptoWallet } from '../../utilities/api'
import SimplyTokenizedLogo from '../../asset/SimplyTokenizedLogo.vue'
import BaseButtonMuted from '../base/BaseButtonMuted.vue'

const loading = ref(false)

function redirectToSimplyTokenized() {
    loading.value = true
    postCryptoWallet(props.requestBody).then((response) => {
        window.location.href = response.data.redirect_url
        loading.value = false
    })
}

const props = defineProps<{
    requestBody: ApiCryptoWalletRequest
}>()
</script>

<template>
    <div class="flex flex-wrap items-center space-y-3 py-12 md:space-y-0">
        <div class="w-full items-center text-center md:w-1/2">
            <BaseButtonMuted size="lg" :disabled="loading" :loading="loading" @click="redirectToSimplyTokenized">
                <span class="font-bold">{{ $t('crypto_wallet.request_wallet_button') }}</span>
            </BaseButtonMuted>
            <div class="flex items-center justify-center py-2">
                <span class="inline-block">via</span>
                <SimplyTokenizedLogo class="ml-2 mt-3 w-32"></SimplyTokenizedLogo>
            </div>
        </div>
        <div class="w-full pb-4 text-sm md:w-1/2">
            <p class="max-w-sm pt-1 text-gray-500">{{ $t('crypto_wallet.notice') }}</p>
        </div>
    </div>
</template>

<style scoped></style>
